import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import { TextSubHeading } from 'blocket-ui'
import ReactPlaceholder from 'react-placeholder/lib'
import { TextRow } from 'react-placeholder/lib/placeholders'
import { PlaceholderWrapper } from 'utils/LoadingAnimationStyles'
import ListResultCountLabel from './ListResultCountLabel'
import SortOptionsDropdown from '../../../components/SortOptionsDropdown'
import CreateAdWatch from './CreateAdWatch'
import FilterButton from './FilterButton'

const searchDescriptionStyles = { width: '35%', marginTop: 0 }
const searchCountStyles = { width: '25%', marginTop: 8 }
const buttonStyles = { height: 32 }

const Placeholder = () => (
  <div className="show-loading-animation">
    <Wrapper>
      <Header>
        <TextRow color="#e1e1e1" style={searchDescriptionStyles} />
        <TextRow color="#e1e1e1" style={searchCountStyles} />
      </Header>
      <ButtonWrapper>
        <TextRow color="#e1e1e1" style={buttonStyles} />
        <TextRow color="#e1e1e1" style={buttonStyles} />
      </ButtonWrapper>
      <BottomRow>
        <TextRow color="#e1e1e1" style={searchDescriptionStyles} />
      </BottomRow>
    </Wrapper>
  </div>
)

const Wrapper = styled.div`
  background-color: #f9f7f6;
  border-bottom: 1px solid #dfdede;
  padding-top: 16px;
`

const Header = styled.div`
  padding: 0 16px 4px;
`

const TopRow = styled(TextSubHeading)`
  display: flex;
  align-items: center;
`

const ButtonWrapper = styled.div`
  padding: 4px 16px;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-column-gap: 8px;
  margin-bottom: 12px;
`

const BottomRow = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 4px 16px;
  background-color: white;
  border-top: 1px solid #dfdede;
`

const SmallLayout = ({
  searchResultDescription,
  searchTotal,
  parameters,
  classifiedActions,
  location,
  currentQuery,
  sortOrderParameter,
  handleChange,
  loading,
}) => (
  <PlaceholderWrapper>
    <ReactPlaceholder ready={!loading} customPlaceholder={<Placeholder />}>
      <Wrapper>
        <Header>
          <TopRow tagName="h1" data-cy="search-result-description">
            {searchResultDescription}
          </TopRow>
          <ListResultCountLabel results={searchTotal} />
        </Header>
        <ButtonWrapper>
          <FilterButton
            classifiedActions={classifiedActions}
            parameters={parameters}
            location={location}
          />
          <CreateAdWatch />
        </ButtonWrapper>
        {sortOrderParameter && (
          <BottomRow>
            <SortOptionsDropdown
              {...sortOrderParameter}
              currentQuery={currentQuery}
              onChange={handleChange}
            />
          </BottomRow>
        )}
      </Wrapper>
    </ReactPlaceholder>
  </PlaceholderWrapper>
)

export default SmallLayout

SmallLayout.propTypes = {
  parameters: PropTypes.array.isRequired,
  classifiedActions: PropTypes.objectOf(PropTypes.func).isRequired,
  location: PropTypes.object.isRequired,
  handleChange: PropTypes.func.isRequired,
  searchResultDescription: PropTypes.node,
  searchTotal: PropTypes.number.isRequired,
  currentQuery: PropTypes.object.isRequired,
  sortOrderParameter: PropTypes.object,
  loading: PropTypes.bool,
}
